import { saveNotificationContent } from '@services/NotificationContentService'
import { useAppSelector } from '@store/hooks'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Update from './Update'

export const NotificatinContentForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const { error } = useAppSelector((state) => state.notificationContent)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          update: Update,
        }}
        handlers={{
          update: async (values) => {
            await saveNotificationContent(values)
            return true
          },
        }}
      />
    )
  }
)

NotificatinContentForm.displayName = 'NotificatinContentForm'

export default NotificatinContentForm
